import { Alert, Button, Flex, Form, Input, Modal, Skeleton } from 'antd';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { API } from '../../../api';
import { notifyError } from '../../../store/utils';

type CustomerApiMemberProps = {
  visible: boolean;
  customer: any;
  onClose: () => void;
};

const CustomerApiMember = ({ visible, customer, onClose }: CustomerApiMemberProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [member, setMember] = useState<any>(null);

  const fetchCustomerApiMember = useCallback(async () => {
    try {
      setLoading(true);
      const { result } = await API.get({ apiVersion: 'api' })(
        `/member/customer/staff/api/${customer.no}`
      );
      const username = !result?.data ? `${customer?.cd}_API` : result?.data?.email;
      form.setFieldsValue({
        username,
        memberNo: result?.data?.no,
        password: undefined,
        confirm: undefined,
      });
      setMember(result?.data || null);
    } catch (error: any) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  }, [customer]);

  const onFinish = useCallback(
    async (values: any) => {
      try {
        setSaveLoading(true);
        await API.post({ apiVersion: 'api' })(`member/customer/staff/api/${customer.no}`, values);
        onClose();
      } catch (error: any) {
      } finally {
        setSaveLoading(false);
      }
    },
    [customer]
  );

  useEffect(() => {
    if (visible && customer) {
      fetchCustomerApiMember();
    }
  }, [visible, customer]);

  return (
    <Modal
      open={visible}
      title="Харилцагчийн API үүсгэх"
      onCancel={onClose}
      footer={false}
      destroyOnClose={true}
    >
      {loading ? (
        <Skeleton />
      ) : (
        <Fragment>
          {member ? (
            <Alert style={{ marginBottom: 24 }} message="API Холболт хийсэн байна" />
          ) : null}
          <Form autoComplete="off" form={form} onFinish={onFinish} layout="vertical">
            <Form.Item hidden name="memberNo">
              <Input />
            </Form.Item>
            <Form.Item
              label="Хэрэглэгчийн нэр"
              name="username"
              rules={[{ required: true, message: 'Хэрэглэгчийн нэр оруулна уу' }]}
            >
              <Input disabled />
            </Form.Item>
            <Form.Item
              label="Хэрэглэгчийн нууц үг"
              name="password"
              rules={[{ required: true, message: 'Хэрэглэгчийн нууц үг оруулна уу' }]}
            >
              <Input.Password autoComplete="new-password" />
            </Form.Item>
            <Form.Item
              name="confirm"
              label="Нууц үг давтах"
              dependencies={['password']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Нууц үг давтах оруулна уу!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Нууц үг зөрж байна!'));
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <Flex justify="end" gap={24}>
                <Button onClick={() => onClose()} htmlType="button">
                  Болих
                </Button>
                <Button loading={saveLoading} type="primary" htmlType="submit">
                  Хадгалах
                </Button>
              </Flex>
            </Form.Item>
          </Form>
        </Fragment>
      )}
    </Modal>
  );
};

export default CustomerApiMember;
